import { create } from 'zustand'

const useServices = create((set) => ({
  currentId: 0,
  seeServices : (id) => set({currentId: id}),
}))

export default useServices;